import { Component, Input, OnInit } from '@angular/core';
import { EventService } from 'src/app/shared/services/event.service';
import { EventInfoWithConsentResponse, RegisterCompanyControllerService, APIResultRegisterCompanyResponse } from '@ent-regis/entregis-ts-angular';
import { AuthService } from 'src/app/shared/services/auth.service';
import { Router, ActivatedRoute } from '@angular/router';
import { first } from 'rxjs/operators';
import { RegisterInvestorService } from 'src/app/core/service/register-investor.service';

@Component({
  selector: 'app-login-header',
  templateUrl: './login-header.component.html',
  styleUrls: ['./login-header.component.scss']
})
export class LoginHeaderComponent implements OnInit {

  @Input() showUserInfo: boolean = true;

  logoUrl: string;
  eventName: string;
  eventInfo: EventInfoWithConsentResponse;
  public personName: string = '';
  public companyName: string = '';

  constructor(
    private eventService: EventService,
    private authService: AuthService,
    private router: Router,
    private route: ActivatedRoute,
    private registerCompanyService: RegisterCompanyControllerService,
    private registerInvestorService: RegisterInvestorService,
  ) { }

  ngOnInit() {
    this.eventService.eventSubject.subscribe(x => {
      if (x) {
        this.logoUrl = x.eventLogoUrl;
        this.eventName = x.eventName;
        this.eventInfo = x;
      }
    });

    if (!this.eventService.eventSubject.getValue()) {
      const eventAlias = this.getEventAliasFromRoute();
      if (eventAlias) {
        this.eventService.loadEventInfo(eventAlias);
      }
    }

    this.personName = this.authService.getName();

    const registerCompanyId = this.getRegisterCompanyId();
    if (registerCompanyId) {
      this.getRegisterCompanyInfo(registerCompanyId);
    }
    const registerInvestorId = this.getRegisterInvestorId();
    if (registerInvestorId) {
      this.getRegisterInvestorInfo();
    }
  }

  private getRegisterCompanyId(): string | null {
    let route = this.route;
    while (route.firstChild) {
      route = route.firstChild;
    }
    return route.snapshot.paramMap.get('registerCompanyId');
  }

  private getEventAliasFromRoute(): string | null {
    let route = this.route;
    while (route.firstChild) {
      route = route.firstChild;
    }
    return route.snapshot.paramMap.get('eventAlias');
  }

  private getRegisterInvestorId(): string | null {
    let route = this.route;
    while (route.firstChild) {
      route = route.firstChild;
    }
    return route.snapshot.paramMap.get('registerInvestorId');
  }

  getRegisterCompanyInfo(registerCompanyId?: string) {
    this.registerCompanyService.getRegisterCompanyByIdUsingGET(Number(registerCompanyId))
      .subscribe((res: APIResultRegisterCompanyResponse) => {
        this.companyName = res.data.companyName;
      });
  }

  getRegisterInvestorInfo() {
    this.registerInvestorService.investorProfile.pipe(first())
    .subscribe(res => {
      this.companyName = res.companyName;
    });
  }

  logout() {
    this.router.navigate(['login', this.authService.eventAlias, this.authService.loginType]);
    this.authService.clear();
  }
}
